import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import CONFIG from 'src/app/app.config';
import { NavigationEnd, Router } from '@angular/router';
import { AuthGuardService } from 'src/app/services/auth-guard/auth-guard.service';
import { AuthenticateService } from 'src/app/services/authenticate/authenticate.service';
import { AnalyticsService } from 'src/app/services/tracking/analytics.service';

declare const jQuery: any;

@Component({
  selector: 'app-menu-nav',
  templateUrl: './menu-nav.component.html',
  styleUrls: ['./menu-nav.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuNavComponent implements OnInit, OnChanges{
  isLoggedIn: Boolean;
  urlPath = CONFIG.APPLICATION.URL;
  alias = CONFIG.APPLICATION.ANALYTICS.SCREENS.AUTHENTICATION;
  appName = CONFIG.APPLICATION.META_DATA.TITLE;
  socialMedia = CONFIG.APPLICATION.URL.SOCIAL_MEDIA;

  @Input() 
  showComponent: Boolean = false;
  @Input()
  step: String = '';
  @Input()
  start: String = '';
  currentRoute: string = '';
  logoMap = {
    [this.urlPath.WELCOME] : 'logo-pos-1',
    [this.urlPath.DECISION] : 'logo-pos-2',
    [this.urlPath.DASHBOARD] : 'logo-pos-3',
    [this.urlPath.SUMMARY] : 'logo-pos-4'
  };
  logoClass = '';
  
  constructor(private router: Router, 
    private authenticateService : AuthenticateService,
    private analyticsService: AnalyticsService) { 
      this.isLoggedIn = this.authenticateService.isAuth();
    }
    
  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this.router.events
      .subscribe((event: Partial<NavigationEnd>) => {
        if(event instanceof NavigationEnd) {
          this.currentRoute = (new URL("http://silly.com" + event.urlAfterRedirects)?.pathname || '')
            .split(/(\/\w+)/)[1];
          this.logoClass = this.logoMap[this.currentRoute] || 'logo-pos-default';
        }
      });
    this.jsCustomScript();

  }
  
  ngOnChanges(changes: SimpleChanges): void {
    //throw new Error('Method not implemented.');
    if(!! changes['showComponent']) {
      this.showComponent = !! changes['showComponent'].currentValue;
    }

    if(!! changes['step']) {
      this.step = changes['step'].currentValue;
    }
  }
  
  logout() {
    this.isLoggedIn = this.authenticateService.invalidateAuth();
    this.analyticsService.logEvent(`${this.alias}-logout`)

    window.location.reload();
  }

  goTo(path : string) {
    // this.router.navigate([path]);
    this.analyticsService.logEvent(`${this.alias}-${path}`)
    window.location.href = path;    
  }

  getImageClass() {
    return this.logoClass;
  }

  jsCustomScript() {
    (function ($) {
      $(document).ready(function(){
        $('[data-bs-toggle="offcanvas"], .nav-item a:not(.dropdown-toggle)').on('click', function () {
          $('.offcanvas-collapse').toggleClass('open')
      });
      });
    })(jQuery);
  }

}
